import React from 'react';
import MUTIL from 'mroads-js-utils';

export default class MenuUtils {
  static parseModifierGroupsToModifiers = (item, showModFunction) => {
    if (!item.modifierGroups) {
      return null;
    }
    if (item.modifierGroups.length > 0) {
      // eslint-disable-next-line arrow-body-style
      let modifiers = item.modifierGroups.reduce((finalModifiers, modifierGroup) => {
        return finalModifiers.concat(
          MenuUtils.convertModifierGroupToModifier(
            modifierGroup,
            showModFunction === undefined ? true : showModFunction,
          ),
        );
      }, []);

      if (modifiers) {
        modifiers = modifiers.filter(modifier => !!modifier);
      }
      return modifiers;
    }
    return null;
  };

  static convertModifierGroupToModifier = (modifierGroup, showModFunction) => {
    if (!modifierGroup.modifiers) {
      return null;
    }

    const modifiers = [];

    modifierGroup.modifiers.forEach(modifier => {
      if (modifier.selected) {
        modifiers.push(MenuUtils.getModifiers(modifier, showModFunction));

        if (modifier.repeatedModifiers) {
          modifier.repeatedModifiers.forEach(repeatedModifier => {
            modifiers.push(MenuUtils.getModifiers(repeatedModifier, showModFunction));
          });
        }
      }
    });
    return modifiers;
  };

  static getModifiers = (modifier, showModFunction) => {
    let tempModifiers = MenuUtils.parseModifierGroupsToModifiers(modifier);
    if (modifier.modFunction && showModFunction) {
      if (!tempModifiers) {
        tempModifiers = [];
      }
      tempModifiers.push({
        modifiers: null,
        menuItemName: modifier.modFunction.name,
        id: MUTIL.generateUniqueId(),
        quantity: 1,
        price: MenuUtils.recursivelyGetPrice(modifier.modFunction),
        modifierId: modifier.modFunction.id,
        ...modifier,
      });
    }
    return {
      modifiers: tempModifiers,
      menuItemName: modifier.name,
      id: MUTIL.generateUniqueId(),
      quantity: 1,
      price: MenuUtils.recursivelyGetPrice(modifier),
      modifierId: modifier.id,
      ...modifier,
    };
  };

  static renderModifiersRecursively = (
    item,
    index = 0,
    modifierRenderer,
    itemRenderer,
    checkModifiers,
  ) => {
    let modifierSelection;

    const modifierParser = (i, checkModifiers) => {
      const modifiers = [];
      i.modifiers &&
        i.modifiers.forEach(m => {
          const modifier = MenuUtils.renderModifiersRecursively(
            m,
            index + 1,
            modifierRenderer,
            modifierRenderer,
            checkModifiers,
          );

          modifiers.push(modifier);
          let repeatedModifiers = [];
          if (m.repeatedModifiers) {
            repeatedModifiers = m.repeatedModifiers.map(repeatedModifier =>
              // eslint-disable-next-line implicit-arrow-linebreak
              MenuUtils.renderModifiersRecursively(
                repeatedModifier,
                index + 1,
                modifierRenderer,
                modifierRenderer,
                checkModifiers,
              ),
            );
          }
          modifiers.push(repeatedModifiers);
        });
      return modifiers;
    };

    if (checkModifiers) {
      modifierSelection = modifierParser(item, checkModifiers);
    } else if (item.modifierGroups) {
      modifierSelection = item.modifierGroups.map(mg => modifierParser(mg, checkModifiers));
    }
    return (
      <div key={`recursively-render-item${index}${item.id}`}>
        {itemRenderer(item, index)}
        {modifierSelection}
      </div>
    );
  };

  static recursivelyGetPrice = item => {
    const modifiers = this.parseModifierGroupsToModifiers(item);
    if (modifiers && modifiers.length > 0) {
      return modifiers
        .map(modifier => {
          // testArray.push[modifier]
          const totalPrice = modifier.price + this.recursivelyGetPrice(modifier);
          return totalPrice;
        })
        .reduce((total, item) => total + item, 0);
    }
    return item.price;
  };

  static getItems = orders => {
    const itemsArray = [];
    orders && orders.forEach(order => {
      order.items &&
        order.items.forEach(item => {
          itemsArray.push({
            ...item,
            checkNumber: order.checkNumber,
            orderDate: order.orderDate,
            orderType: order.orderType,
            serverName: order.serverName,
            stationId: order.stationId,
            stationName: order.stationName,
          });
        });
    });
    return itemsArray;
  };

}
